import { Layer } from './layer';
import olMap from 'ol/Map';
import { CalculationsService } from 'src/app/services/calculations.service';
import { DocSectorizationDisplayService } from 'src/app/services/doc-sectorization-display.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { FlightInspectionCSVFields } from 'src/app/models/ImportCSV';

export class TopLevelLayers{
  active:boolean = false;
  name:string = '';
  calcID?:number;
  layers:Layer[];
  calculationsService?:CalculationsService;
  docAndSectorSercive?:DocSectorizationDisplayService;
  modalConfirmation:ModalConfirmationService;
  type:string = "DEFAULT";
  map:olMap;
  legend: String[] = [];
  navaids:String[] = [];
  navaids_info = new Map<string, String[]>();
  navaids_expanded_info = new Map<string, boolean>();
  elevation_info = new Map<string, string>();
  horizon_tool_info = new Map<string, string>();
  cumulative_coverage_colors : string[];
  overlap_frequency_colors: Map<string, string[]> = new Map<string, string[]>();
  obstacleFileName: string;
  status: boolean = false;

  //flight inspection
  flightInspection_attributes: FlightInspectionCSVFields[];
  //Processing Tool
  processingTool_attributes: any[];

  public static readonly DEFAULT_Z_INDEX = 1;

  index_selected: number;
  flightInspectionId: number;
  layerSelected: boolean = false;
  constructor(active:boolean, name:string, layers:Layer[], map:olMap, modalConfirmation: ModalConfirmationService, calculationsService?:CalculationsService, docAndSectorSercive? : DocSectorizationDisplayService, calcID?:number, type?:string,
    obstacleFileName?: string,

    ) {
    this.active = active;
    this.name = name;
    this.layers = layers;
    this.calcID = calcID;
    this.calculationsService = calculationsService;
    this.docAndSectorSercive = docAndSectorSercive;
    this.modalConfirmation = modalConfirmation;
    this.obstacleFileName = obstacleFileName;

    if(type != undefined){
      this.type = type;
    }

    this.map = map;


    layers.forEach(element => {
      if(element.olLayer != null){
        if (!element.olLayer.getZIndex()){
          element.olLayer.setZIndex(TopLevelLayers.DEFAULT_Z_INDEX);
        }
        element.olLayer.setVisible(element.visible);
        map.addLayer(element.olLayer);
      }
    });
  }

  addLayers(layers:Layer[]){
    layers.forEach(element => {
      if(element.olLayer != null){
        element.olLayer.setVisible(element.visible);
        this.layers.push(element);
        this.map.addLayer(element.olLayer);
      }
    });
  }
  getLayerByName(name: string): Layer {
    var thisMap = this.map;
    this.layers.forEach(element => {
      if(element.olLayer != null && element.name == name ){
        return element;
      }
    });
    return null;
  }

  removeFromMap(){
    var thisMap = this.map;
    this.layers.forEach(element => {
      if(element.olLayer != null){
        element.olLayer.setVisible(false);
        thisMap.removeLayer(element.olLayer);
      }
    });
  }

  layersTabTrigger():void {
    this.active = !this.active;
  }

  public static onSelect(layer:Layer): void{
    layer.visible = !layer.visible;
    layer.olLayer.setVisible(layer.visible);
  }

  onSelectDocSectorization(navaid:String): void{
    this.layers.forEach(layer => {
      let navaid_name: string = layer.olLayer.getSource().getFeatures()[0].getProperties().NA;
      if(navaid_name != undefined && navaid_name == navaid){
        layer.visible = !layer.visible;
        layer.olLayer.setVisible(layer.visible);
      }
    })
  }

  displayLegend(navaid:string):void {
   this.navaids_expanded_info.set(navaid, !this.navaids_expanded_info.get(navaid));
  }

  allVisible():boolean{
    for(var layer of this.layers){
        if(!layer.visible){
          return false;
        }
    }

    return true;
  }

  deleteCalculation(type: string,deleteTabFunction,deleteAll?:boolean){
    if(this.calculationsService){
      if(deleteAll){
        // no confirmation needed
        this.calculationsService.deleteCalculation(this.calcID);
        deleteTabFunction(this.calcID);
      }
      else{
        this.modalConfirmation.showMesssageConfirmationModal("Delete Calculation", "Do you want to delete the selected Calculation?", "Yes", "No",
         () =>
        { this.calculationsService.deleteCalculation(this.calcID);
          deleteTabFunction(this.calcID);
            
        });
      }
    }else {
      this.modalConfirmation.showMesssageConfirmationModal("Delete Calculation", "Do you want to delete the selected Calculation?", "Yes", "No", () => this.docAndSectorSercive.deleteCalculation(this.calcID));
    }
  }
  deleteLayerByName(name: string): void {
    var thisMap = this.map;
    this.layers.forEach(element => {
      if(element.olLayer != null && element.name == name ){
        element.olLayer.setVisible(false);
        thisMap.removeLayer(element.olLayer);
        this.layers.splice(this.layers.indexOf(element) ,1);
      }
    });
  }

  clicked():void{
    if(this.type == "PROCEDURE_ANALYSIS")
      this.calculationsService.showBarChart(this.calcID);
  }

  showAll():void{
    /*if(this.name.startsWith("Procedure Analysis - "))
      this.calculationsService.showBarChart(this.calcID);*/
    this.layers.forEach(layer=>{layer.visible = true; layer.olLayer.setVisible(true)});
  }

  hideAll():void{
    this.layers.forEach(layer=>{layer.visible = false; layer.olLayer.setVisible(false)});
  }

  oneVisible():boolean{
    for(var layer of this.layers){
        if(layer.visible){
          return true;
        }
    }

    return false;
  }



}
